import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import apiJurados from "../api/Jurados/api-jurados";
import { Area, Categoria } from "../models/JuradosModel/jurados.model";
import { RootState } from "../redux/reducers";
import {
  guardarEducacionJurado,
  juradoEditar,
  juradoAtras,
  menuJuradoAction,
} from "../redux/actions/juradosAction";
import apiMaestras from "../api/Maestras/api-maestras";
import { openNotification } from "../utils/Notifactions";

export const useCategoriasJurados = () => {
  // const { jurado } = useSelector((state: RootState) => state);
  const { editarJurado, jurado_atras, menuJurado } = useSelector(
    (state: RootState) => state.jurado
  );
  const idJurado = localStorage.getItem('idJurado')
  //console.log(idJurado);
  // const jurados = useSelector((state: RootState) => state.jurado);
  // console.log(jurados);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [counter, setCounter] = useState(0);
  const [loading, setLoading] = useState(false);

  const { estadoFormulario } = useParams();

  const refCheckBox = useRef<any>();
  const [categoriasSelected, setCategoriasSelected] = useState<Categoria[]>([]);
  const handleCheckBoxChange = (
    value: boolean,
    name: string,
    categorias: Categoria[],
    indexprincipal: number,
    index: number
  ) => {
    //
    let infoupdate: any = [...areas];
    let checkeds = infoupdate.map((area: any) => {
      let result = area.categorias_areas.filter(
        (check: any) => check.checked === true
      );
      return result.length;
    });
    let result = 0;
    for (let i in checkeds) {
      result = result + checkeds[i];
    }
    if (result < 3) {
      //
      if (value) {
        setCounter(counter + 1);
      } else {
        setCounter(counter - 1);
      }
      // console.log(value)
      infoupdate[indexprincipal].categorias_areas[index].checked = value;
      setCategoriasSelected(infoupdate);
      return setAreas(infoupdate);
    }

    if (result <= 5 && value === false) {
      setCounter(counter - 1);
      infoupdate[indexprincipal].categorias_areas[index].checked = value;
      setCategoriasSelected(infoupdate);
      return setAreas(infoupdate);
    }
  };

  const getAreasCategoriasJurado = async () => {
    try {
      const { areas } = await apiMaestras.obtenerAreasConCategorias();
      const areasFilter = areas.map((area: any) => {
        return {
          ...area,
          categorias_areas: area.categorias_areas.map((c: any) => {
            return {
              ...c,
              checked: false,
            };
          }),
        };
      });
      var response: any = await apiJurados.obtenerAreasCategoriasJurado(
        Number(idJurado)
      );
      response = response[0];
      
      let infoupdate = [...areasFilter];
      for (let i in infoupdate) {
        for (let x in infoupdate[i].categorias_areas) {
          let existe = response.areas_conocimientos.filter(
            (data: any) => infoupdate[i].categorias_areas[x].id === data.id
          );
          if (existe.length > 0) {
            infoupdate[i].categorias_areas[x].checked = true;
          } else {
            infoupdate[i].categorias_areas[x].checked = false;
          }
        }
      }

      setAreaPrincipal(response.area_principal);
      setConocimiento(response.tipo_conocimiento);
      return setAreas(infoupdate);
    } catch (error) {
      console.log(error);
    }
  };

  const [areas, setAreas] = useState<Area[]>([]);
  const getAreas = async () => {
    try {
      const { areas } = await apiMaestras.obtenerAreasConCategorias();

      // console.log(areas, 'acá')
      const areasFilter = areas.map((area: any) => {
        return {
          ...area,
          categorias_areas: area.categorias_areas.map((c: any) => {
            return {
              ...c,
              checked: false,
            };
          }),
        };
      });
      setAreas(areasFilter);
    } catch (error) {
      console.log(error);
    }
  };

  const [conocimiento, setConocimiento] = useState<any>(null);
  const handleConocimientoChange = (value: number) => {
    dispatch(guardarEducacionJurado(value));
    setConocimiento(value);
  };

  const [areaPrincipal, setAreaPrincipal] = useState<any>(null);

  const handleAreaPrincipalChange = (value: number, option: any) => {
    setAreaPrincipal(value);
    localStorage.setItem("areaPrincipalOption", option.children);
    console.log('escogiendo:::', value)
    console.log(option.children)
  };

  const handleSubmit = async () => {
    var areasfiltradas: any = [];
    areas.filter((x) => {
      x.categorias_areas.filter((c) => {
        if (c.checked === true) {
          areasfiltradas = [...areasfiltradas, c];
        }
      });
    });

    let payload = {
      // juradoId: jurado.idJurado,
      tipo_conocimiento: conocimiento,
      area_principal: areaPrincipal,
      areas_conocimientos: areasfiltradas,
    };
    console.log('areaPrincipal', areaPrincipal)
    console.log('areasfiltradas', areasfiltradas)
    localStorage.setItem("tipoConocimiento", conocimiento);
    localStorage.setItem("areaPrincipal", areaPrincipal);
    areasfiltradas.push({ id: 0, nombre: conocimiento, checked: true });
    console.log(areasfiltradas)
    localStorage.setItem("areasFiltradas", JSON.stringify(areasfiltradas));

    if (payload.areas_conocimientos.length === 0 || payload.areas_conocimientos.length === 1) {
      return openNotification({
        titulo: "Error",
        descripcion: "Debe seleccionar las áreas de conocimiento",
        placement: "bottomRight",
      });
    }

    if (!payload.area_principal || !payload.tipo_conocimiento) {
      return openNotification({
        titulo: "Error",
        descripcion: "Seleccione un área principal y un tipo conocimiento",
        placement: "bottomRight",
      });
    }

    try {
      setLoading(true);
      if (editarJurado) {
        dispatch(juradoEditar(false));
        setLoading(false);
        return navigate("/usuario/estadosFormulario");
      }

      if (estadoFormulario != "" && estadoFormulario != undefined) {
        dispatch(juradoEditar(false));
        setLoading(false);
        return navigate("/usuario/estadosFormulario");
      }

      if (jurado_atras) {
        if (conocimiento === 2) {
          return navigate("/usuario/educacionNoFormal");
        }

        dispatch(juradoAtras(false));
        setLoading(false);
        return navigate("/usuario/educacionFormal");
      }

      if (menuJurado) {
        dispatch(menuJuradoAction(false));
        setLoading(false);
        return navigate("/usuario/MenuJurado");
      }

      if (conocimiento === 2) {
        setLoading(false);
        return navigate("/usuario/educacionNoFormal");
      }
      setLoading(false);
      return navigate("/usuario/educacionFormal");
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const prevScreen = () => {
    dispatch(juradoAtras(true));
    return navigate("/usuario/Registrarjurado");
  };

  useEffect(() => {
    //
    let mounted = true;
    if (mounted) {
      if (jurado_atras) {
        getAreasCategoriasJurado();
      } else {
        getAreas();
      }
    }
    return () => {
      mounted = false;
    };
  }, []);

  return {
    areas,
    categoriasSelected,
    handleCheckBoxChange,
    refCheckBox,
    handleSubmit,
    handleConocimientoChange,
    handleAreaPrincipalChange,
    prevScreen,
    areaPrincipal,
    conocimiento,
    counter,
    loading,
  };
};
